import React from 'react'

import { Button } from 'react-toolbox/lib/button'

export default class FulcrumButton extends React.Component {
  render() {
    return (
      <Button {...this.props}/>
    )
  }
}
